export const CACHE_MAX_DURATION = 43200000; // = 12 hours
